import { SvgIcon, SxProps } from "@mui/material";
import SvgEnvelopeIcon from "jsx:../../../Images/Icons/FontAwesome/light/envelope.svg";

export function EnvelopeIcon(props: SxProps) {
    return <SvgIcon component={SvgEnvelopeIcon} inheritViewBox sx={props} />;
}
